export class TurmaSemChamadaSemana {
  turmaId?: string;
  nome?: string;
  ano?: number | null;

  constructor(data?: Partial<TurmaSemChamadaSemana>) {
    if (data) Object.assign(this, data);
  }
}

export class FaltaSemanaAnterior {
  turmaId?: string;
  turmaNome?: string;
  pessoaId?: string;
  pessoaNome?: string;
  totalFaltasNaSemana = 0;

  constructor(data?: Partial<FaltaSemanaAnterior>) {
    if (data) Object.assign(this, data);
  }
}

export class DashboardFrequenciaSemana {
  semanaAnteriorInicio?: string;
  semanaAnteriorFim?: string;
  turmasSemChamada?: TurmaSemChamadaSemana[];
  faltasNaSemana?: FaltaSemanaAnterior[];

  constructor(data?: Partial<DashboardFrequenciaSemana>) {
    if (data) Object.assign(this, data);
  }
}
